import { render, staticRenderFns } from "./bag-icon.vue?vue&type=template&id=13b0983c"
import script from "./bag-icon.vue?vue&type=script&lang=js"
export * from "./bag-icon.vue?vue&type=script&lang=js"
import style0 from "./bag-icon.vue?vue&type=style&index=0&id=13b0983c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports